export enum SnackbarActionEnum {
	ERROR = 'Error',
	SUCCESS = 'Success',
	ALERT = 'Alert'
}
